export default {
  submitReservation: 'Submit reservation',
  mobileSubmitReservation: 'Finish',
  home: {
    description: 'Book your flight now',
    button: 'Enter the app',
  },
  flights: {
    title: 'Select a Flight',
    from: 'From',
    to: 'To',
    oneWay: 'One Way',
    roundTrip: 'Round Trip',
    passengers: 'Passengers',
    adults: 'Adults',
    infants: 'Infants',
    dateSelection: 'Choose departing date',
    datesSelection: 'Choose departing dates',
    flight: 'Flight',
    seats: 'Seats',
    available: 'Available',
    offlineReservation: 'Offline reservation only (call for assistance)',
    flightFull: 'Flight full',
    highDemand: 'High demand',
    passengersSelection: 'Select number of passengers',
    noFlightsAvailable: 'Something went wrong, no flights available',
    selectDate: 'Choose a date',
    calendarLegend: 'Legend',
  },
  passengers: {
    title: 'Select passengers',
    add: 'Add passenger',
    selectRelationship: 'Relationship',
    noPassengers: 'You have no passengers/contacts, please add new passenger/contact',
    noSelectedPassengers:
      'You have no selected passengers/contacts for flight, please select at least 1 passenger/contact',
    noPassengersForSearch: 'You have no passengers/contacts containing: ',
    find: 'Find passengers',
  },
  passenger: {
    editTitle: 'Edit Passenger/Contact',
    addTitle: 'Add a new Passenger/Contact',
    firstName: 'First Name',
    lastName: 'Last Name',
    phone: 'Cell Phone',
    email: 'E-mail Address',
    infant: 'This passenger is an Infant',
    birthday: 'Date of Birth',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    save: 'Save',
    close: 'Close',
  },
  seats: {
    title: 'Select a seat',
    open: 'Open',
    selected: 'Selected',
    reserved: 'Reserved',
    notAvailable: 'Not Available',
    info: {
      title: 'Infants and exit row seating details',
      exitRow: 'Passengers in Exit Rows must be at least 16 years old',
      infants:
        'Infants: Selecting a seat for your infant is optional. Should you choose a seat, your infant is guaranteed a seat and a segment will be deducted from your account. If you choose not to select a seat, your infant is not guaranteed a seat and you will not be charged a segment.',
    },
  },
  seat: {
    seat: 'Seat ',
    select: 'Choose a seat',
    title: 'Select a seat for passenger ',
  },
  meals: {
    title: 'Select a meal',
    noMeals: 'You have no meals selected',
    noMealsAvailable: 'There is no available meals for selected flight',
  },
  meal: {
    meal: 'Meal ',
    notes: 'Special instructions',
    notesPlaceholder: 'Please write down your instructions',
    appetizer: 'Appetizer',
    mainMeal: 'Main meal ',
    dessert: 'Dessert ',
    select: 'Choose a meal',
    title: 'Choose a meal for ',
    done: 'Done',
  },
  review: {
    title: 'Book your flight',
    konaShuttle: 'Kona Shuttle',
    flight: 'Flight',
    passenger: 'Passenger',
    seat: 'Seat',
    noSeat: 'None',
    meal: 'Meal',
    noMeals: 'Incomplete',
    from: 'From',
    to: 'To',
    confirm: 'Book now',
    printTitle: 'Review itinerary',
    print: 'Print',
  },
  terms: {
    title: 'Terms & Conditions',
    error: 'You must check the checkbox below in order to submit your reservation.',
    checkbox: 'I agree to the Terms & Conditions',
    accept: 'Accept',
    cancel: 'Cancel',
  },
  step: {
    flights: 'Select Flight',
    passengers: 'Select Passengers',
    seats: 'Select Seats',
    meals: 'Choose Meals',
    review: 'Review Reservation',
    prev: 'Go Back',
    next: 'Next Step',
    mobilePrev: 'Back',
    mobileNext: 'Next',
    reservationsuccessful: 'Submit Reservation',
    exit: 'Exit',
  },
  reservationSuccessful: {
    title: 'Air Reservation Successful',
    reservation: 'Reservation',
    print: 'Print reservation',
    continue: 'Continue to reservations list',
  },
  notifications: {
    infoTitle: 'Info Notification',
    successTitle: 'Success Notification',
    warningTitle: 'Warning Notification',
    errorTitle: 'Error occured',
    close: 'Close',
  },
  youHaveSelected: 'You have selected ',
  and: ' and ',
  translateNumberOfAdults: (adultsSelected, adultsTotal) =>
    `${adultsSelected} of ${adultsTotal} adults`,
  translateNumberOfInfants: (infantsSelected, infantsTotal) =>
    `${infantsSelected} of ${infantsTotal} infants`,
};



// WEBPACK FOOTER //
// ./src/model/Dictionary.js